<div class="data-collection-icon__bottom-card"></div>
<div class="data-collection-icon__middle-card"></div>
<div class="data-collection-icon__top-card">
    <span class="data-collection-icon__initials" [textContent]="name | initials"></span>
</div>